export const messages = {
  required: "Field is required",
  email: "Enter a valid email",
  number: "Enter a valid number",
};

export const styleBg = (tabIndex, value) => {
  return tabIndex === value ? {
    bgcolor: '#616b88',
    marginRight: 1,
    borderTopRightRadius: 10,
    borderTopLeftRadius: 10,
    color: '#fff !important',
  } : {
    bgcolor: '#b5bcd2',
    border: 1,
    borderColor: 'divider',
    borderTopRightRadius: 10,
    borderTopLeftRadius: 10,
    marginRight: 1,
    color: '#7a839f !important',
  };
};
